import { jsx as h, jsxs as l } from "react/jsx-runtime";
import "react";
var t = (v) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...v,
  children: [
    /* @__PURE__ */ h("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#F0F0F0",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#D80027",
      d: "M39.83 17.391H22.61V.17a20.198 20.198 0 0 0-5.218 0v17.222H.17a20.198 20.198 0 0 0 0 5.218h17.222v17.22a20.193 20.193 0 0 0 5.218 0V22.609h17.22a20.191 20.191 0 0 0 0-5.218Z"
    }),
    /* @__PURE__ */ h("path", {
      fill: "#D80027",
      d: "M12.174 9.565V6.957H9.565v2.608H6.957v2.609h2.608v2.609h2.609v-2.609h2.609V9.565h-2.609Zm18.261 0V6.957h-2.609v2.608h-2.609v2.609h2.61v2.609h2.608v-2.609h2.609V9.565h-2.61ZM12.174 27.826v-2.609H9.565v2.61H6.957v2.608h2.608v2.609h2.609v-2.61h2.609v-2.608h-2.609Zm18.261 0v-2.609h-2.609v2.61h-2.609v2.608h2.61v2.609h2.608v-2.61h2.609v-2.608h-2.61Z"
    })
  ]
});
export {
  t as default
};
